export enum MoneyPotStatus {
  Closed = 'CLOSED',
  Validation = 'VALIDATION',
  Used = 'USED',
  Open = 'OPEN'
}
